
<ng-container *ngIf="!textOnly">
  <select class="form-control" [id]="inputId" [name]="inputName" [(ngModel)]="value" [disabled]="disabled">
    <option value="" *ngIf="blank !== false"></option>
    <option *ngFor="let country of filteredCountries" [value]="country.countryId">{{ country.countryName }}</option>
  </select>
  <validation-error-display [error]="error" [field]="inputName"></validation-error-display>
</ng-container>
<ng-container *ngIf="textOnly">
  <div class="input-group border-bottom"><span class="text-secondary pl-2">{{countryText}}</span></div>
</ng-container>